import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import Presentation from "@project/templates/home/Presentation";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/system/Stack";
import NumbersPart from "./NumbersPart";
import Surtitle from "@project/components/Surtitle";
import DecorativeBackgroundBox from "./DecorativeBackgroundBox";
const HomeTemplate = (props) => {
    const { page } = props;
    const { contents } = page || {};
    const { autoScrollingClientsPart, descriptionEditable, subDescriptionEditable, cardsGrid, titleTechPart, subtitleTechPart, autoScrollingInfoPart, titleProductsPart, subtitleProductsPart, dynamicProductPart, dynamicPart, } = contents;
    return (_jsxs(_Fragment, { children: [_jsx(Presentation, { ...props }), _jsx(Container, { sx: {
                    maxWidth: "1308px !important",
                }, children: _jsx(Box, { children: autoScrollingClientsPart }) }), _jsx(Box, { sx: {
                    position: "relative",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        backgroundImage: "url('/pattern-left.png')",
                        backgroundPosition: "left",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        inset: 0,
                        zIndex: -1,
                        display: { xs: "none", md: "block" },
                    },
                    "&::after": {
                        content: '""',
                        position: "absolute",
                        backgroundImage: "url('/pattern-right.png')",
                        backgroundPosition: "right",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        inset: 0,
                        zIndex: -1,
                        display: { xs: "none", md: "block" },
                    },
                }, children: _jsx(Container, { sx: {
                        maxWidth: "848px !important",
                        py: { xs: "60px", md: "120px" },
                    }, children: _jsxs(Stack, { spacing: 3, sx: { alignItems: "center" }, children: [_jsx(Typography, { variant: "h2", component: "p", color: "primary.contrastText", sx: {
                                    "& span": {
                                        fontSize: { xs: "24px !important", sm: "34px !important" },
                                    },
                                }, children: descriptionEditable }), _jsx(Typography, { variant: "h5", component: "p", color: "primary.contrastText", sx: {
                                    "& span": {
                                        fontSize: { xs: "16px !important", sm: "20px !important" },
                                    },
                                }, children: subDescriptionEditable })] }) }) }), _jsx(NumbersPart, { page: page }), _jsx(Box, { sx: { position: "relative" }, children: _jsxs(Container, { sx: {
                        maxWidth: "1208px !important",
                        py: { xs: "60px", sm: "120px" },
                    }, children: [_jsx(DecorativeBackgroundBox, { side: "left", top: "50%", transform: "translateY(-50%)" }), cardsGrid] }) }), _jsx(Box, { sx: {
                    backgroundColor: "background.header",
                    py: { xs: "60px", sm: "120px" },
                    backgroundImage: "url('/fond-waves.png')",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                }, children: _jsx(Container, { sx: {
                        maxWidth: "1208px !important",
                    }, children: _jsxs(Stack, { spacing: 5, children: [_jsxs(Stack, { spacing: 2, children: [_jsx(Surtitle, { title: titleTechPart, contrast: true }), _jsx(Typography, { component: "p", variant: "h3", sx: { color: "primary.contrastText" }, children: subtitleTechPart })] }), _jsx(Box, { children: autoScrollingInfoPart })] }) }) }), _jsx(Box, { sx: { position: "relative" }, children: _jsxs(Container, { sx: {
                        maxWidth: "1208px !important",
                        py: { xs: "60px", sm: "120px" },
                    }, children: [_jsx(DecorativeBackgroundBox, { side: "right", top: "316px" }), _jsxs(Stack, { spacing: 2, children: [_jsx(Surtitle, { title: titleProductsPart }), _jsx(Typography, { component: "p", variant: "h3", children: subtitleProductsPart })] }), _jsx(Box, { children: dynamicProductPart })] }) }), _jsx(Box, { children: dynamicPart })] }));
};
export default HomeTemplate;
